import React, { useEffect } from 'react';
import ScrollableFilters from '../Rules/components/ScrollableFilters';
import { useScrollableFilters } from '../Rules/hooks/useScrollableFilters';

/*
  FilterBar: self-managing horizontal filter row with edge fades and
  scroll arrows. Wraps the existing ScrollableFilters presentation and
  owns the scroll-state wiring so pages don't have to.

  Usage: <FilterBar>{buttons / fields}</FilterBar>
*/

export default function FilterBar({ children, sx }) {
  const {
    scrollRef,
    showLeftScroll,
    showRightScroll,
    scrollLeft,
    scrollRight,
    checkScrollButtons,
  } = useScrollableFilters();

  // Re-measure when the filter content changes (e.g. chips appear/disappear).
  useEffect(() => {
    checkScrollButtons();
  }, [children, checkScrollButtons]);

  return (
    <ScrollableFilters
      scrollRef={scrollRef}
      showLeftScroll={showLeftScroll}
      showRightScroll={showRightScroll}
      onScrollLeft={scrollLeft}
      onScrollRight={scrollRight}
      sx={sx}
    >
      {children}
    </ScrollableFilters>
  );
}
